import { isDayjs } from 'dayjs'
import * as yup from 'yup'

declare module 'yup' {
  interface StringSchema {
    /**
     * @description Transform dayjs object or 'Invalid Date' string to undefined so required() validation catches it. Dayjs objects can be coerced to 'Invalid Date' after being coerced from .string()
     * @returns The schema
     */
    coerceDayjsString(): this
  }
}

// Attach to number schema type only
yup.addMethod(yup.string, 'coerceDayjsString', function () {
  return this.transform((value) => {
    // Handle Dayjs objects - convert valid ones to ISO strings, invalid ones to null
    if (isDayjs(value)) {
      return value.isValid() ? value.toISOString() : null
    }

    // Handle string values which can be 'Invalid Date' after being coerced from .string()
    if (value === 'Invalid Date') {
      return null
    }
    return value
  })
})

export {}
